import React, { useState } from "react";

import Box from "@mui/material/Box";
import { DataGrid, GridToolbarContainer, GridToolbarExport, } from "@mui/x-data-grid";

import { Grid, Paper, Typography, Button, TextField } from "@mui/material";

import axios from "../../../../api/axios";

const URL = "./claim/report/monthly";

export default function ClaimMonthlyReport() {
  const [month, setMonth] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());

  const [rows, setRows] = useState([]);

  const [totalRequested, setTotalRequested] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport
          csvOptions={{
            fileName: "vehicle_warranty",
            utf8WithBom: true,
          }}
          printOptions={{
            disableToolbarButton: true,
          }}
        />
      </GridToolbarContainer>
    );
  }

  const columns = [
    {
      field: "vinNo",
      headerName: "VIN",
      width: 180,
    },

    {
      field: "customerFirstName",
      headerName: "Customer",
      width: 180,
    },

    {
      field: "dealership",
      headerName: "Dealership",
      width: 220,
    },

    {
      field: "requestedClaimAmount",
      headerName: "Requested",
      width: 170,
      renderCell: (params) => `$${params.value ?? 0}`,
    },

    {
      field: "paidClaimAmount",
      headerName: "Paid",
      width: 170,
      renderCell: (params) => `$${params.value ?? 0}`,
    },
  ];
  const searchReport = async () => {
    if (!month) {
      alert("Please Select Month");
      return;
    }

    try {
      const response = await axios.post(URL, {
        month,
      });

      setRows(response.data.data || []);

      setTotalRequested(response.data.totalRequestedClaimAmount || 0);

      setTotalPaid(response.data.totalPaidClaimAmount || 0);
    } catch (err) {
      console.log(err);

      alert("No Records Found");

      setRows([]);

      setTotalRequested(0);

      setTotalPaid(0);
    }
  };

  return (
    <Box sx={{ marginTop: "100px" }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold" }}>
        Monthly Claim Report
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={4}>
          <TextField
            fullWidth
            label="Month"
            type="month"
            InputLabelProps={{
              shrink: true,
            }}
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          />
        </Grid>

        <Grid item xs={2}>
          <Button
            fullWidth
            variant="contained"
            sx={{
              height: 55,
            }}
            onClick={searchReport}
          >
            Search
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={3}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle2">Total Requested Claim</Typography>

            <Typography variant="h5">${totalRequested.toFixed(2)}</Typography>
          </Paper>
        </Grid>

        <Grid item xs={3}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle2">Total Paid Claim</Typography>

            <Typography variant="h5">${totalPaid.toFixed(2)}</Typography>
          </Paper>
        </Grid>
      </Grid>

      <Box sx={{ mt: 3 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={[10, 25, 50, 100]}
          pagination
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
                page: 0,
              },
            },
          }}
          slots={{
            toolbar: CustomToolbar,
          }}
          autoHeight
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
          }}
        />
      </Box>
    </Box>
  );
}
